// extracted by mini-css-extract-plugin
module.exports = {"box_custom_style":"EpochDetail_box_custom_style__ETuFn"};